var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ApolloLink, Observable, } from 'apollo-link';
import { openRenewModal } from '../utils/renewModal';
import { getValidToken } from '../logic/auth';
import { track } from '@food/tracking';
import { authTrackOverride } from '../utils/track';
export var RenewLink = function (auth) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.request = function (operation, forward) {
            var observableResult = forward(operation);
            return new Observable(function (observer) {
                observableResult.subscribe({
                    next: function (x) {
                        var response = operation.getContext().response;
                        var newToken = response.headers.get('authorization');
                        if (newToken) {
                            auth.setAuthToken(newToken);
                        }
                        observer.next(x);
                    },
                    complete: function () {
                        observer.complete();
                    },
                    error: function (err) {
                        // intercetto gli errori per mancata / scaduta autenticazione
                        if (err.response && err.response.status === 401) {
                            track(__assign(__assign({}, authTrackOverride), { action: { type: 'auth_expired' } }));
                            try {
                                openRenewModal({}).then(function (loginResult) {
                                    if (loginResult) {
                                        operation.setContext(function (context) { return (__assign(__assign({}, context), { headers: __assign(__assign({}, context.headers), { authorization: getValidToken() }) })); });
                                        forward(operation).subscribe({
                                            next: function (x) {
                                                observer.next(x);
                                            },
                                            complete: function () {
                                                observer.complete();
                                            },
                                            error: function (e) {
                                                observer.error(e);
                                            },
                                        });
                                    }
                                }, function (asd) {
                                    observer.error(asd);
                                });
                            }
                            catch (e) {
                                observer.error(e);
                            }
                        }
                        else {
                            observer.error(err);
                        }
                    },
                });
            });
        };
        return class_1;
    }(ApolloLink));
};
//# sourceMappingURL=RenewLink.js.map